import React, { useState, useEffect } from 'react';

/**
 * Komponent App - wersja z zaawansowaną diagnostyką ładowania obrazu.
 */
export default function App() {
  const [scrolled, setScrolled] = useState(false);
  const [particles, setParticles] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(false);

  // Ścieżka do pliku - w React z folderu 'public' zawsze zaczynamy od '/'
  const imagePath = "/hoorn.jpg";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const newParticles = Array.from({ length: 50 }).map((_, i) => ({
      id: i,
      size: Math.random() * 2 + 1,
      left: Math.random() * 100,
      top: Math.random() * 100,
      duration: Math.random() * 10 + 5,
      delay: Math.random() * 5,
    }));
    setParticles(newParticles);
  }, []);

  return (
    <>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700&family=Montserrat:wght@200;300;400;600;700&display=swap');

        :root {
            --bg-dark: #010203;
            --text-main: #ffffff;
            --text-muted: #94a3b8;
            --accent-cyan: #00d2ff;
            --accent-cyan-glow: rgba(0, 210, 255, 0.4);
            --font-heading: 'Cinzel', serif;
            --font-body: 'Montserrat', sans-serif;
        }

        * { margin: 0; padding: 0; box-sizing: border-box; }
        body {
            background-color: var(--bg-dark);
            color: var(--text-main);
            font-family: var(--font-body);
            overflow: hidden;
        }

        nav {
            position: fixed; top: 0; left: 0; width: 100%;
            padding: 20px 50px; z-index: 1000; transition: all 0.4s ease;
        }
        nav.scrolled {
            backdrop-filter: blur(15px); background: rgba(1, 2, 3, 0.9);
            border-bottom: 1px solid rgba(0, 210, 255, 0.15);
        }

        .hero {
            position: relative; width: 100%; height: 100vh; display: flex;
            flex-direction: column; align-items: center; justify-content: center; overflow: hidden;
        }

        #particles-container {
            position: absolute; top: 0; left: 0; width: 100%; height: 100%;
            z-index: 1; pointer-events: none;
        }

        .particle {
            position: absolute; border-radius: 50%; background: rgba(255, 255, 255, 0.4);
            box-shadow: 0 0 5px var(--accent-cyan-glow); opacity: 0; animation: floatParticle linear infinite;
        }

        @keyframes floatParticle {
            0% { transform: translateY(0) scale(0.5); opacity: 0; }
            30% { opacity: 0.8; }
            70% { opacity: 0.5; }
            100% { transform: translateY(-150px) scale(1.5); opacity: 0; }
        }

        .sketch-image {
            position: absolute; width: 100%; height: 100%; object-fit: contain;
            z-index: 2; opacity: 0; transform: scale(0.95);
            filter: invert(1) grayscale(1) contrast(1.8) brightness(1.1);
            transition: opacity 2s ease, transform 10s ease-out;
        }

        .sketch-image.visible {
            opacity: 0.8;
            transform: scale(1.05);
        }

        .image-mask {
            position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 3;
            background: radial-gradient(circle at center, transparent 30%, var(--bg-dark) 85%), 
                        linear-gradient(to bottom, transparent 60%, var(--bg-dark) 95%);
            pointer-events: none;
        }

        .hero-content { position: absolute; bottom: 20%; text-align: center; z-index: 10; pointer-events: none; }
        
        .title-main {
            font-family: var(--font-heading); font-size: 5rem; font-weight: 600; letter-spacing: 20px;
            margin: 0; text-transform: uppercase; background: linear-gradient(120deg, #444 0%, #fff 40%, #fff 60%, #444 100%);
            background-size: 200% auto; color: transparent; -webkit-background-clip: text; background-clip: text;
            animation: textSlideUp 2.5s 0.5s cubic-bezier(0.2, 0.8, 0.2, 1) forwards, textLightSweep 5s infinite linear;
            text-shadow: 0 10px 30px rgba(0,0,0,0.5);
        }

        .title-sub {
            font-family: var(--font-body); font-weight: 700; font-size: 1.8rem; letter-spacing: 35px;
            color: var(--accent-cyan); margin-top: 15px; margin-right: -35px;
            text-shadow: 0 0 15px var(--accent-cyan-glow);
            animation: subTextReveal 2s 1.5s ease-out forwards;
            opacity: 0;
        }

        @keyframes textSlideUp {
            0% { opacity: 0; transform: translateY(30px); filter: blur(10px); }
            100% { opacity: 1; transform: translateY(0); filter: blur(0px); }
        }
        @keyframes textLightSweep { to { background-position: 200% center; } }
        @keyframes subTextReveal {
            0% { opacity: 0; transform: translateY(10px); letter-spacing: 15px; }
            100% { opacity: 0.9; transform: translateY(0); letter-spacing: 35px; }
        }

        .error-msg {
            position: absolute; z-index: 100; background: rgba(255,0,0,0.1);
            border: 1px solid red; padding: 20px; color: white; text-align: center;
            max-width: 80%; backdrop-filter: blur(10px); border-radius: 8px;
        }

        footer {
            background-color: #010102; padding: 40px 10%; border-top: 1px solid rgba(255,255,255,0.05);
            display: flex; flex-direction: column; align-items: center; justify-content: center;
        }
        .social-links a { color: var(--text-muted); font-size: 1.5rem; transition: 0.3s; }
        .social-links a:hover { color: var(--accent-cyan); filter: drop-shadow(0 0 8px var(--accent-cyan-glow)); }
        .copyright { color: rgba(255,255,255,0.2); font-size: 0.75rem; margin-top: 20px; }
      `}</style>

      <nav className={scrolled ? 'scrolled' : ''}></nav>

      <header className="hero" id="home">
        <div id="particles-container">
          {particles.map(p => (
            <div key={p.id} className="particle" style={{
                width: p.size, height: p.size, left: p.left + 'vw', top: p.top + 'vh',
                animationDuration: p.duration + 's', animationDelay: p.delay + 's'
            }} />
          ))}
        </div>

        {/* Diagnostyka błędu */}
        {loadError && (
          <div className="error-msg">
            <i className="fa-solid fa-triangle-exclamation" style={{fontSize: '2rem', marginBottom: '10px'}}></i>
            <p><strong>Błąd:</strong> Nie można załadować pliku <code>{imagePath}</code></p>
            <p style={{fontSize: '0.8rem', marginTop: '10px'}}>
              Upewnij się, że plik <code>hoorn.jpg</code> znajduje się w folderze <code>public/</code><br/>
              Sprawdź, czy nazwa pliku nie zawiera dużych liter (np. <code>.JPG</code>)
            </p>
          </div>
        )}

        <img
          src={imagePath}
          alt="Main Tower"
          className={`sketch-image ${isLoaded ? 'visible' : ''}`}
          onLoad={() => { setIsLoaded(true); setLoadError(false); }}
          onError={() => { setLoadError(true); }}
        />

        <div className="image-mask"></div>

        <div className="hero-content">
          <h1 className="title-main">Main Tower</h1>
          <div className="title-sub">Interactive</div>
        </div>
      </header>

      <footer id="footer">
        <div className="social-links">
          <a href="#twitter"><i className="fa-brands fa-x-twitter"></i></a>
        </div>
        <div className="copyright">
          &copy; {new Date().getFullYear()} Main Tower Interactive. Hoorn, Holandia.
        </div>
      </footer>
    </>
  );
}